import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from "react-quill";
import ImageResize from "quill-image-resize-module-react";

import { Card, CardContent } from "./ui/card";
import { cn } from "../lib/utils";

// Make Quill available globally for the resize module
window.Quill = Quill;

// Fix delete/backspace issue in quill-image-resize-module-react
const originalCheckImage = ImageResize.prototype.checkImage;

ImageResize.prototype.checkImage = function (event) {
  if (this.img && (event.keyCode === 46 || event.keyCode === 8)) {
    const blot = window.Quill.find(this.img);

    // Only delete if Quill can still find the image
    if (blot) {
      blot.deleteAt(0);
    }

    // Always hide resize controls
    this.hide();

    return;
  }

  if (originalCheckImage) {
    return originalCheckImage.call(this, event);
  }
};

Quill.register("modules/imageResize", ImageResize);

function Editor({ value, setValue, image = false }) {
  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      // [{ script: "sub" }, { script: "super" }],
      [{ header: [1, 2, 3, false] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      image ? ["link", "image", "blockquote"] : ["link", "blockquote"],
      ["clean"],
    ],

    ...(image && {
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },
    }),
  };

  return (
    <Card className="max-w-full border-none">
      <CardContent className="p-0 border-none">
        <div className={cn("rounded-md border-none")}>
          <ReactQuill
            theme="snow"
            value={value || ""}
            onChange={(content, delta, source, editor) => {
              setValue(content);
            }}
            modules={modules}
            className={cn(
              "min-h-full",
              "[&_.ql-toolbar]:rounded-t-md [&_.ql-container]:rounded-b-md",
              "[&_.ql-toolbar]:border-b [&_.ql-toolbar]:bg-webPrimary [&_.ql-toolbar]:text-white",
              "[&_.ql-container]:border-0 [&_.ql-container]:bg-background [&_.ql-editor]:p-4 [&_.ql-editor]:text-sm"
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default Editor;
